// src/UserMinusIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var UserMinusIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "15",
    height: "22",
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.41788 0.472656C4.66688 0.472656 2.43038 2.70916 2.43038 5.46016C2.43038 8.15866 4.54088 10.3427 7.29188 10.4372C7.37588 10.4267 7.45988 10.4267 7.52288 10.4372C7.54388 10.4372 7.55438 10.4372 7.57538 10.4372C7.58588 10.4372 7.58588 10.4372 7.59638 10.4372C10.2844 10.3427 12.3949 8.15866 12.4054 5.46016C12.4054 2.70916 10.1689 0.472656 7.41788 0.472656Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.7519 13.2407C9.82238 11.2877 5.04488 11.2877 2.09438 13.2407C0.760879 14.1227 0.0258789 15.3302 0.0258789 16.6217C0.0258789 17.9132 0.760879 19.1102 2.08388 19.9922C3.55388 20.9792 5.48588 21.4727 7.41788 21.4727C9.34988 21.4727 11.2819 20.9792 12.7519 19.9922C14.0749 19.0997 14.8099 17.9027 14.8099 16.6007C14.7994 15.3197 14.0749 14.1122 12.7519 13.2407ZM9.33938 17.3462H5.50688C5.10788 17.3462 4.78238 17.0207 4.78238 16.6217C4.78238 16.2227 5.10788 15.8972 5.50688 15.8972H9.33938C9.73838 15.8972 10.0639 16.2227 10.0639 16.6217C10.0639 17.0207 9.73838 17.3462 9.33938 17.3462Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var UserMinusIcon_default = UserMinusIcon;

export {
  UserMinusIcon_default
};
